/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Solitaire/GameModes/FreeCellGameMode',[
        'Solitaire/GameModes/GameModeBase',
        'Solitaire/GameModes/IGameMode',
        'Solitaire/Solitaire',
        'Solitaire/SolitaireGameMode',
        'SolitaireShared/FreeCellTemplate/FreeCellWindowsTemplate',
        'SolitaireShared/CardLogic/Supply',
        'Solitaire/GameResult',
        'Solitaire/GameState',
        'Solitaire/SolitaireStatistics'
    ],
function (GameModeBase, IGameMode, SolitaireGame, SolitaireGameMode, FreeCellWindowsTemplate, Supply, GameResult, GameState, SolitaireStatistics) {
    "use strict";
    
    var FreeCellGameMode = function () {
            this.initFreeCellGameMode();
        };

        FreeCellGameMode.constructor = FreeCellGameMode;
        FreeCellGameMode.prototype = Object.create(GameModeBase.prototype);
        IGameMode.call(FreeCellGameMode.prototype);

        FreeCellGameMode.prototype.initFreeCellGameMode = function () {
            this.Name = SolitaireGameMode.FreeCell;
        };

        Object.defineProperty(FreeCellGameMode.prototype, "TimerOption", {
            get: function () {
                if (GameState.CurrentGame.Authority.IsChallenge) {
                    return GameState.CurrentGame.Authority.TimerEnabled ? IGameMode.TimerSettings.CountDown : IGameMode.TimerSettings.CountUp;
                }
                return IGameMode.TimerSettings.CountUp;
            }
        });

        FreeCellGameMode.prototype.OnMoveCardButton = function () {
        };

        FreeCellGameMode.prototype.IsUpdateDealButtonsVisible = function () {
            return false;
        };

        FreeCellGameMode.prototype.IsUpdateDrawButtonVisible = function () {
            return false;
        };

        FreeCellGameMode.prototype.ConfigureSolitairePage = function (page) {
            Supply.UseCumulativeScoring = false;
        };

        FreeCellGameMode.prototype.CreateTemplate = function () {
            return new FreeCellWindowsTemplate();
        };

        FreeCellGameMode.prototype.GetCheatMoves = function () {
            return "G FREECELL D 49897363627438679165818481216805914107022257796838332724511239606694 M 12 5 1 M 12 5 1 [7] M 12 13 1 [9] M 13 12 2 [15] M 13 14 2 [17] M 15 9 1 [17] M 15 3 1 [39] M 11 8 1 [39] M 14 11 3 [45] M 14 13 1 [45] M 14 6 1 [52] M 17 14 1 [56] M 14 12 1 [56] M 12 14 1 [59] U 1 [60] U 1 [61] U 1 [68] M 12 10 1 [73] M 14 12 1 [74] M 18 14 1 [74] M 18 4 1 [75] M 12 14 2 [79] M 17 14 1 [88] M 11 16 2 [236] M 15 17 1 [237] M 15 7 1 [237] M 15 6 1 [239] M 15 6 1 [239] M 7 6 1 [242] M 17 15 2 [246] M 11 15 2 [252] M 17 14 1 [257] M 17 7 1 [257] M 17 3 1 [257] M 17 5 1 [286] M 12 17 1 [287] M 12 3 1 [287] M 9 3 1 [289] M 11 3 1 [289] M 11 4 1 [292] M 17 11 1 [294] M 11 17 2 [296] M 11 12 1 [298] M 11 5 1 [299] M 7 5 1 [305] M 18 7 1 [307] M 7 11 1 [307] M 12 11 2 [307] M 12 6 1 [318] M 14 17 4 [319] M 13 17 1 [321] M 18 16 1 [323] M 16 11 4 [327] M 18 7 1 [338] M 8 12 1 [339] M 7 12 1 [340] M 16 9 1 [341] M 16 17 1 [342] M 16 14 1 [342] M 16 4 1 [342] M 18 4 1 [343] M 9 4 1 [343] M 17 4 1 [370] M 14 18 3 [381] M 12 14 2 [386] M 16 13 1 [389] M 13 16 2 [389] M 13 3 1 [390] M 13 5 1 [390] M 14 4 1 [396] M 10 18 1 [397] M 13 18 1 [398] M 16 18 2 [399] M 15 16 4 [401] M 11 15 7 [404] M 15 13 7 [404] M 16 15 4 [407] M 13 16 7 [408] M 15 11 4 [410] M 11 13 4 [410] N ";
        };

        FreeCellGameMode.prototype.HelpDataSource = function () {
            return null; // TODO not supported? return SimpleIoc.Default.GetInstance<MvvmStructure.Model.SpiderHelpDataSource>();
        };

        FreeCellGameMode.prototype.ButtonsPostion = function (invertAxis) {
            return null; // TODO not supported?
            //return new Dictionary<GameButtons, Vector2>();
        };

        FreeCellGameMode.prototype.GetGameEnd = function () {
            throw "TODO";
            return null;
            /*
             var model = new GameEndModel
                {
                    LockIconSourcePath = "Assets/ui/icons/update.png",
                };

                model.AddStatValue("Time", LocalizationManager.GetString("Time_Title/Text"));
                model.AddStatValue("BestTime", LocalizationManager.GetString("BestTime_Title/Text"));
                model.AddStatValue("GamesPlayed", LocalizationManager.GetString("GamesPlayed_Title/Text"));
                model.AddStatValue("GamesWon", LocalizationManager.GetString("GamesWon_Title/Text"));
                model.AddStatValue("WinPercentage", LocalizationManager.GetString("WinPercentage_Title/Text"));
                model.Optional1ButtonText = LocalizationManager.GetString("OptionalButton_TryAgain");
                model.Optional1Visibility = Visibility.Visible;
                SetDefaults(model);
                model.UpdateStatistics = UpdateStatistics;
                return model;
             */
        };    
            
        FreeCellGameMode.prototype.SetShare = function (args) {
            // TODO
            /*
             var description = new StringBuilder();
                var message = new StringBuilder();
                var gameTitle = "";
                gameTitle = SetDefaultShareMessage(description, message,Name.ToString());
                message.Replace("%GAME_TITLE%", gameTitle).Replace("%SCORE%",SolitaireStatistics.Current.GetPercentWon(GetStatKey()));
                ShareManager.SetShareMessage(args, gameTitle, description, message);
             */
        };

        FreeCellGameMode.GetStatKeyStatic = function () {
            return new SolitaireStatistics.StatKey(
                GameState.CurrentGame.ActiveMode.Name,
                (SolitaireGameMode.getModeById(GameState.CurrentGame.ActiveMode.Name)).toUpperCase());

        };

        FreeCellGameMode.prototype.GetStatKey = function () {
            return FreeCellGameMode.GetStatKeyStatic();
        };

        FreeCellGameMode.prototype.UpdateStatistics = function (model) {
            //if (GameState.CurrentGame.ActiveMode.Name == SolitaireGameMode.Unknown) return;

            var statkey = FreeCellGameMode.GetStatKeyStatic();

            if (GameState.CurrentGame.GameResult == GameResult.Win)
            {
                //User Won here so update stats and save them to disk
                SolitaireStatistics.Current.UpdateGameWon(statkey);
                //model.Optional1ButtonText = "";
                //model.Optional1Visibility = Visibility.Collapsed;
            }
            else if (GameState.Current == GameState.GameComplete)
            {
                //User Lost here so update stats and save them to disk
                SolitaireStatistics.Current.UpdateGameLost(statkey);
                //model.Optional1ButtonText = LocalizationManager.GetString("OptionalButton_TryAgain");
                //model.Optional1Visibility = Visibility.Visible;
            }

            //Update GameEnd Model with Latest Stats
            /*
            model.UpdateStatValue("Time", SolitaireStatistics.Current.GetTimeFormatString(statkey));
            model.UpdateStatValue("BestTime", SolitaireStatistics.Current.GetBestTimeFormatString(statkey));
            model.UpdateStatValue("GamesPlayed", SolitaireStatistics.Current.GetGamesPlayedFormatString(statkey));
            model.UpdateStatValue("GamesWon", SolitaireStatistics.Current.GetGamesWonFormatString(statkey));
            model.UpdateStatValue("WinPercentage", SolitaireStatistics.Current.GetPercentWon(statkey));
            */
            model["Time"] = SolitaireStatistics.Current.GetTimeFormatString(statkey);
            model["BestTime"] = SolitaireStatistics.Current.GetBestTimeFormatString(statkey);
            model["GamesPlayed"] = SolitaireStatistics.Current.GetGamesPlayedFormatString(statkey);
            model["GamesWon"] = SolitaireStatistics.Current.GetGamesWonFormatString(statkey);
            model["WinPercentage"] = SolitaireStatistics.Current.GetPercentWon(statkey);

        };
            
        FreeCellGameMode.prototype.UpdateLeaderBoard = function () {
            // unsupported
            /*
             var current = GameState.CurrentGame;
                if ( App.CurrentApp.GameNetClient.Settings.XblConnected)
                {
                    ResultObject<string> result; //string result;
                    result = await App.CurrentApp.GameNetClient.LeaderboardManager.SaveScore((int)SolitaireStatistics.Current.GetBestTime(GetStatKey()), 7, Microsoft.Xbox.Leaderboards.LeaderboardAggregation.Min);
                    //result = await App.CurrentApp.GameNetClient.LeaderboardManager.SaveScore((int)SolitaireStatistics.Current.GetLongestWinningStreak(GetStatKey()), 8, Microsoft.Xbox.Leaderboards.LeaderboardAggregation.Replace);
                    result = await App.CurrentApp.GameNetClient.LeaderboardManager.SaveScore((int)(Math.Round(SolitaireStatistics.Current.GetWinPercentage(GetStatKey()) * 100.0)), 9, Microsoft.Xbox.Leaderboards.LeaderboardAggregation.Replace);
                }
             */
        };    

        return FreeCellGameMode;

});
